import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'content-loading-list',
    templateUrl: './content-loading-list.component.html',
    styleUrls: ['./content-loading-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentLoadingListComponent {

  constructor() { }

}